export const UNKOWNDISTRICTCODE = "00";